import { withProtectedRoute, roles } from 'lib/auth'
import TransactionHistory from './transaction-history'

export default withProtectedRoute(TransactionHistory, [
  roles.COACH,
  roles.CONSUMER,
])
